import HasLabel from "./HasLabel";
import TrackedObject from "./TrackedObject";

export interface AdhocDash extends TrackedObject {
    dashboardId: string;
    title: string;
    definition: string;
}

export class AdhocDash extends HasLabel {
    constructor(obj?: AdhocDash) {
        super();
        if (obj) Object.assign(this, obj);
    }

    toString(): string {
        if (this.title) return this.title;
        return this.dashboardId;
    }

    formatSearchOptions(objects: Array<any>, searchComponent: any): Array<any> {
        if (!objects?.length) return objects;

        const mine = objects.filter(o => o.isMine);
        const team = objects.filter(o => !o.isMine && o.isTeam);
        const other = objects.filter(o => o.id !== 0 && !o.isMine && !o.isTeam);

        const uniqueTeams = new Map();

        const userName = searchComponent.$user?.userName?.toLowerCase();

        team.forEach(item => {
            if (!item.sharedWithTeams) return;
            item.sharedWithTeams.filter((t: any) => t.users.some((u: any) => u.userName?.toLowerCase() === userName))
                .forEach((t: any) => {
                    if (uniqueTeams.has(t.id)) return;
                    uniqueTeams.set(t.id, t.name);
                });
        });

        const teamDashboards: any[] = [];

        uniqueTeams.forEach((value, key) => {
            teamDashboards.push({ heading: true, label: `${value} Team Dashboards`, visible: true });
            teamDashboards.push(...team.filter(o => o.sharedWithTeams.some((t: any) => t.id === key)));
        })

        return [
            { heading: true, label: `My Dashboards`, visible: !!mine.length },
            ...mine,
            ...teamDashboards,
            { heading: true, label: `Other Dashboards`, visible: !!other.length },
            ...other,
            { heading: true, label: '', visible: true },
            ...objects.filter(o => o.id === 0)
        ].filter(o => o.visible !== false);
    }
}